export * from './accommodation-details';
export * from './accommodation-details.props';
